/** GA4 → Meta. Eventos ausentes deste mapa não vão para o Pixel (CA-13). */
const EQUIVALENTES = {
  view_item: "ViewContent",
  add_to_cart: "AddToCart",
  begin_checkout: "InitiateCheckout",
  purchase: "Purchase",
  search: "Search",
};

/** Evento equivalente no Meta, ou null quando não há (CA-13). */
export function metaEventFor(name) {
  return EQUIVALENTES[name] ?? null;
}

/** Converte parâmetros GA4 para o formato do Meta (CA-13). */
export function metaParamsFor(_name, params = {}) {
  const itens = params.items ?? [];
  const meta = {};

  if (itens.length) {
    meta.content_ids = itens.map((item) => item.item_id);
    meta.content_type = "product";
    meta.contents = itens.map((item) => ({
      id: item.item_id,
      quantity: item.quantity,
      item_price: item.price,
    }));
  }
  if (params.value !== undefined) {
    meta.value = params.value;
  }
  if (params.currency !== undefined) {
    meta.currency = params.currency;
  }
  if (params.search_term !== undefined) {
    meta.search_string = params.search_term;
  }
  return meta;
}

/**
 * Identificador do evento para dedupe futura com a Conversions API (CA-20).
 * Com semente (o `orderId` do `purchase`) é determinístico; sem ela, único por disparo.
 */
export function eventId(name, seed) {
  if (seed !== undefined && seed !== null && seed !== "") {
    return `${name}.${seed}`;
  }
  const aleatorio = globalThis.crypto?.randomUUID?.() ??
    `${Date.now()}.${Math.random().toString(36).slice(2)}`;
  return `${name}.${aleatorio}`;
}
